import { render, staticRenderFns } from "./FormFazendaDialog.vue?vue&type=template&id=24dee44e"
import script from "./FormFazendaDialog.vue?vue&type=script&lang=js"
export * from "./FormFazendaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports